/**
 * Issue Billing Key Use Case
 * 빌링키 발급 유스케이스
 */

import type { BillingRepository } from '../../repositories/BillingRepository';
import type { BillingKeyIssueRequest } from '../../models/payments/Billing';

export class IssueBillingKeyUseCase {
  constructor(private readonly billingRepository: BillingRepository) {}

  async execute(request: BillingKeyIssueRequest): Promise<void> {
    await this.billingRepository.issueBillingKey(request);
  }
}
